import { ChevronDown } from 'lucide-react';
import {
  type ForwardedRef,
  forwardRef,
  type ReactElement,
  type SelectHTMLAttributes,
} from 'react';

import { cn } from '@/shared/lib/cn';

export type SelectProps = SelectHTMLAttributes<HTMLSelectElement>;

export const Select = forwardRef(function Select(
  { className, children, ...props }: SelectProps,
  ref: ForwardedRef<HTMLSelectElement>,
): ReactElement {
  return (
    <div className="relative">
      <select
        ref={ref}
        className={cn(
          'flex h-10 w-full appearance-none rounded-md border border-input bg-background px-3 py-2 pr-9 text-sm shadow-soft-1',
          'transition-[border-color,box-shadow] duration-150 ease-out-expo',
          'focus-visible:outline-none focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/40',
          'disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        {...props}
      >
        {children}
      </select>
      <ChevronDown
        aria-hidden
        className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground"
      />
    </div>
  );
});
